// extracted by mini-css-extract-plugin
module.exports = {"subscriptionList":"styles_subscriptionList__ErQid"};